/* eslint-disable no-unused-vars */
import axios from "axios";

// API endpoints
const API_BASE_URL =
  "https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3";
const SOCIAL_ENDPOINT = "/social-content";

/**
 * Fetch policies with pagination and optional filtering
 *
 * @param {number} page - Current page number (1-based)
 * @param {number} pageSize - Number of results per page
 * @param {string} searchTerm - Optional search term to filter policies
 * @param {string} policyArea - Optional policy area to filter by
 * @returns {Promise} - Promise containing paginated policy data
 */
export const fetchSocial = async (claim_result, platform, url) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/social`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          claim_result: claim_result,
          platform: platform,
          url: url,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data.content;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
